"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountBaseResponseToJSON = exports.AdAccountBaseResponseFromJSONTyped = exports.AdAccountBaseResponseFromJSON = exports.instanceOfAdAccountBaseResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AdAccountBaseResponse interface.
 */
function instanceOfAdAccountBaseResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAccountBaseResponse = instanceOfAdAccountBaseResponse;
function AdAccountBaseResponseFromJSON(json) {
    return AdAccountBaseResponseFromJSONTyped(json, false);
}
exports.AdAccountBaseResponseFromJSON = AdAccountBaseResponseFromJSON;
function AdAccountBaseResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'businessId': !(0, runtime_1.exists)(json, 'business_id') ? undefined : json['business_id'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
    };
}
exports.AdAccountBaseResponseFromJSONTyped = AdAccountBaseResponseFromJSONTyped;
function AdAccountBaseResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'business_id': value.businessId,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
exports.AdAccountBaseResponseToJSON = AdAccountBaseResponseToJSON;
